"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotomeasureButton = void 0;
var core_api_1 = require("@ikegps/core-api");
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var photomeasure_button_style_1 = require("./photomeasure.button.style");
(0, theme_1.addStyles)(photomeasure_button_style_1.Style);
function stopPropagation(e) {
    e.stopPropagation();
}
exports.PhotomeasureButton = {
    view: function (tagId, collectionUUID) {
        '';
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.PHOTO_MEASURE, {
            title: index_1.T.LINK_PHOTOMEASURE,
            className: photomeasure_button_style_1.CSS.container,
            href: page_1.IkePageName.collectionMeasure,
            hrefParams: {
                d: services_1.Services.Department.current.objectId,
                t: tagId,
                collection: collectionUUID
            },
            disabled: false,
            onclick: stopPropagation
        });
    },
    getParams: function (tagId, collectionUUID) {
        return {
            d: services_1.Services.Department.current.objectId,
            t: tagId,
            collection: collectionUUID
        };
    },
    getUrl: function (tagId, collectionId, collectionUUID) {
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_EDIT)) {
            var departmentId = services_1.Services.Department.current.objectId;
            return collectionUUID != null ? "measure?d=".concat(departmentId, "&t=").concat(tagId, "&collection=").concat(collectionUUID) : "measure?d=".concat(departmentId, "&t=").concat(tagId);
        }
        return collectionId != null ? "m/".concat(tagId, "/").concat(collectionId) : "m/".concat(tagId);
    }
};
//# sourceMappingURL=photomeasure.button.js.map